var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayroll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 13C17 13.8284 16.3284 14.5 15.5 14.5C14.6716 14.5 14 13.8284 14 13C14 12.1716 14.6716 11.5 15.5 11.5C16.3284 11.5 17 12.1716 17 13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8132 5.72788L15.8132 2.58502C17.4102 2.12872 19 3.32788 19 4.98883V6.00024C20.1046 6.00024 21 6.89567 21 8.00024V18.0002C21 19.1048 20.1046 20.0002 19 20.0002H5C3.89543 20.0002 3 19.1048 3 18.0002V8.00024C3 6.95568 3.83483 6.00741 4.8132 5.72788ZM16.3626 4.50807C16.682 4.41681 17 4.65664 17 4.98883V6.00024H11.1401L16.3626 4.50807ZM5 8.00024H19V18.0002H5C5 15.0153 5 8.00024 5 8.00024Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayroll);
export default __webpack_public_path__ + "static/media/payroll.81a8f6cb8b252a4dad59ca6cacfc461e.svg";
export { ForwardRef as ReactComponent };